import React, { useState } from "react";
import { Trans } from "react-i18next";
import { LoadingAlert } from "../../../../../../boxes/LoadingAlert/LoadingAlert";
import { useAppTranslation } from "../../../../../../i18n/useAppTranslation";
import { Button } from "../../../../../../shared/Button/Button";
import { CircularProgress } from "../../../../../../shared/CircularProgress/CircularProgress";
import { usePatientFi } from "../../../hooks/usePatientFi";
import CountdownTimer from "../../../../../../shared/CountdownTimer/CountdownTimer";
import styles from "./OnGoingPaymentBox.module.scss";
import { uiNotification } from "../../../../../../services/UINotificationService";

const OnGoingPaymentBox = ({ onCancelPayment, isCancelling = false }) => {
  const { tSales } = useAppTranslation.Sales();
  const { tCommon } = useAppTranslation.Common();
  const { resendNotification } = usePatientFi();
  const [resendAvailable, setResendAvailable] = useState(false);

  const handleResend = () => {
    const dto = {
      sms: true,
      email: true,
    };
    resendNotification.mutate(dto, {
      onSuccess: (res) => {
        setResendAvailable(false);
        uiNotification.success(res.data.message);
      },
      onError: () => {
        uiNotification.error();
      },
    });
  };

  return (
    <LoadingAlert>
      <Trans
        i18nKey={tSales("checkoutInvoice.warn.awaitingForPfiPayment")}
        components={{
          b: <b />,
        }}
      />
      <div className={styles.buttonsContainer}>
        <div>
          <Button
            size="small"
            color="warn"
            variant={!resendAvailable ? "outlined" : "contained"}
            onClick={handleResend}
            isDisabled={!resendAvailable || resendNotification.isLoading}
            leftAdornment={
              resendNotification.isLoading ? (
                <CircularProgress size="tiny" color="white" />
              ) : undefined
            }
          >
            Resend Payment Link
          </Button>
          {!resendAvailable && (
            <span className={styles.resendInfoText}>
              Resend available in{" "}
              <CountdownTimer
                start={60}
                onFinish={() => setResendAvailable(true)}
              />{" "}
              seconds.
            </span>
          )}
        </div>
        <Button
          size="small"
          color="warn"
          onClick={onCancelPayment}
          isDisabled={isCancelling}
          leftAdornment={
            isCancelling ? (
              <CircularProgress size="tiny" color="white" />
            ) : undefined
          }
        >
          {tCommon("label.cancelPayment")}
        </Button>
      </div>
    </LoadingAlert>
  );
};

export default OnGoingPaymentBox;
